/**
 * Gallery – Lightbox & Filtering
 * The Color – thecolor.uk
 *
 * Handles:
 *  - Category filter buttons
 *  - Lightbox open / close / navigate
 *  - Keyboard navigation (Escape, ArrowLeft, ArrowRight)
 *  - Focus trapping inside the lightbox
 */

(function () {
  'use strict';

  /* -----------------------------------------------------------------------
     1. Category Filtering
     ----------------------------------------------------------------------- */

  const filterBtns = document.querySelectorAll('[data-gallery-filter]');
  const galleryItems = document.querySelectorAll('[data-gallery-category]');

  if (filterBtns.length && galleryItems.length) {
    filterBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        const category = btn.dataset.galleryFilter;

        // Update active state
        filterBtns.forEach((b) => b.classList.remove('tc-gallery-grid__filter--active'));
        btn.classList.add('tc-gallery-grid__filter--active');

        // Filter items
        galleryItems.forEach((item) => {
          if (category === 'all' || item.dataset.galleryCategory === category) {
            item.style.display = '';
            item.removeAttribute('hidden');
          } else {
            item.style.display = 'none';
            item.setAttribute('hidden', '');
          }
        });
      });
    });
  }

  /* -----------------------------------------------------------------------
     2. Lightbox
     ----------------------------------------------------------------------- */

  const lightbox = document.getElementById('gallery-lightbox');
  const lightboxImg = lightbox?.querySelector('[data-lightbox-img]');
  const lightboxCaption = lightbox?.querySelector('[data-lightbox-caption]');
  const lightboxClose = lightbox?.querySelector('[data-lightbox-close]');
  const lightboxPrev = lightbox?.querySelector('[data-lightbox-prev]');
  const lightboxNext = lightbox?.querySelector('[data-lightbox-next]');
  const lightboxCounter = lightbox?.querySelector('[data-lightbox-counter]');
  const triggers = document.querySelectorAll('[data-lightbox-trigger]');

  let currentIndex = 0;
  let visibleTriggers = [];
  let releaseFocus = null;

  function getVisibleTriggers() {
    return Array.from(triggers).filter(
      (t) => !t.closest('[hidden]') && t.closest('[data-gallery-category]')?.style.display !== 'none'
    );
  }

  function openLightbox(index) {
    if (!lightbox || !lightboxImg) return;

    visibleTriggers = getVisibleTriggers();
    currentIndex = index;
    updateLightboxContent();

    lightbox.removeAttribute('hidden');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    // Trap focus inside lightbox
    if (window.TheColor && window.TheColor.trapFocus) {
      releaseFocus = window.TheColor.trapFocus(lightbox);
    }

    lightboxClose?.focus();
  }

  function closeLightbox() {
    if (!lightbox) return;

    lightbox.setAttribute('hidden', '');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';

    // Release focus trap
    if (releaseFocus) {
      releaseFocus();
      releaseFocus = null;
    }

    // Return focus to the trigger
    visibleTriggers[currentIndex]?.focus();
  }

  function updateLightboxContent() {
    const trigger = visibleTriggers[currentIndex];
    if (!trigger || !lightboxImg) return;

    const src = trigger.dataset.lightboxSrc || trigger.querySelector('img')?.src || '';
    const caption = trigger.dataset.lightboxCaption || '';

    lightboxImg.src = src;
    lightboxImg.alt = caption || 'Gallery image';

    if (lightboxCaption) {
      lightboxCaption.textContent = caption;
      lightboxCaption.style.display = caption ? '' : 'none';
    }

    if (lightboxCounter) {
      lightboxCounter.textContent = `${currentIndex + 1} / ${visibleTriggers.length}`;
    }

    // Toggle prev/next visibility
    if (lightboxPrev) lightboxPrev.style.display = visibleTriggers.length > 1 ? '' : 'none';
    if (lightboxNext) lightboxNext.style.display = visibleTriggers.length > 1 ? '' : 'none';
  }

  function navigateLightbox(direction) {
    if (visibleTriggers.length <= 1) return;

    currentIndex = (currentIndex + direction + visibleTriggers.length) % visibleTriggers.length;
    updateLightboxContent();
  }

  // Bind trigger clicks
  triggers.forEach((trigger, i) => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const visible = getVisibleTriggers();
      const idx = visible.indexOf(trigger);
      openLightbox(idx >= 0 ? idx : 0);
    });
  });

  // Close button
  lightboxClose?.addEventListener('click', closeLightbox);

  // Navigation
  lightboxPrev?.addEventListener('click', () => navigateLightbox(-1));
  lightboxNext?.addEventListener('click', () => navigateLightbox(1));

  // Backdrop click
  lightbox?.addEventListener('click', (e) => {
    if (e.target === lightbox || e.target.classList.contains('tc-lightbox__backdrop')) {
      closeLightbox();
    }
  });

  // Keyboard navigation
  document.addEventListener('keydown', (e) => {
    if (!lightbox || lightbox.hasAttribute('hidden')) return;

    switch (e.key) {
      case 'Escape':
        closeLightbox();
        break;
      case 'ArrowLeft':
        navigateLightbox(-1);
        break;
      case 'ArrowRight':
        navigateLightbox(1);
        break;
    }
  });
})();
